import { Component, forwardRef, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  IbgeService,
  RegionTree,
  Region,
} from 'src/app/shared/services/ibge.service';
import { warningAlert } from '../../helpers/swal-defaults';

type Level = 'region' | 'state' | 'city' | 'mesoregion' | 'microregion';

interface ExpansibleRegionTree extends RegionTree {
  expanded?: boolean;
  selected?: boolean;
  children?: ExpansibleRegionTree[];
}

@Component({
  selector: 'app-localization',
  templateUrl: './localization.component.html',
  styleUrls: ['./localization.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocalizationComponent),
      multi: true,
    },
  ],
})
export class LocalizationComponent implements OnInit, ControlValueAccessor {
  _value: number[] = [];
  regionList: ExpansibleRegionTree[];
  selectedCities: ExpansibleRegionTree[] = [];
  showAllSelectedCities: boolean = false;
  @Input() selected:any= [];

  get value(): number[] {
    return this._value;
  }

  set value(value: number[]) {
    this._value = value || [];
    this.onChange(this._value);
    this.onTouched();
  }

  constructor(private ibgeService: IbgeService) {}

  async ngOnInit() {
    this.selected.filter((s)=>{
      return parseInt(s);
    })

    this.regionList = await this.ibgeService.getTreeRegions();
    this.recurse(this.regionList)
    
    this.getSelectedCities();
    this.setInit(this.selected)
  }

  recurse(node) {
    node.map((r)=>{
      if(this.selected.includes(r.value.toString())){   
        this.toggleItem(r);
        r.selected = true;
        r.expanded = true;
      }
      if(r.children){
        this.recurse(r.children)
      }
    })
  }
  
  ngOnChanges(changes: SimpleChanges) {
  }

  async remove(city: ExpansibleRegionTree) {
    if (!city.selected) {
      return;
    }
    city.selected = false;
    this.toggleItem(city);
  }


  async removeAll() {
    
    const { isConfirmed } = await warningAlert.fire(
      'Tem certeza?',
      'Deseja mesmo remover todas as cidades?'
    );
    if (!isConfirmed) {
      return;
    }
    this.selectedCities.forEach(x => x.selected = false);
    this.writeValue([]);
  }


  toggleItem(item: ExpansibleRegionTree) {
    const newVal = this.value,
      foundIndex = newVal.findIndex((x) => x === item.value);
    if (foundIndex > -1) {
      newVal.splice(foundIndex, 1);
    } else {
      newVal.push(item.value);
    }
    //this.writeValue(newVal);
  }

  setInit(values){
    const newVal = this.value;

    values.forEach(value => {
      const foundIndex = newVal.findIndex((x) => x === value);
      if (foundIndex === -1) {
        newVal.push(value);
      }
    });
    this.writeValue(newVal);
  }

  selectChildren(item: ExpansibleRegionTree) {
    const values: number[] = [];

    (function select(node: ExpansibleRegionTree) {
      if (node.children) {
        node.children.forEach((child) => select(child));
      } else {
        node.selected = true;
        values.push(node.value);
      }
    })(item);

    const newVal = this.value;

    values.forEach(value => {
      const foundIndex = newVal.findIndex((x) => x === value);
      if (foundIndex === -1) {
        newVal.push(value);
      }
    });
    this.writeValue(newVal);
  }

  getSelectedCities(citiesIds = this.value) {
    if (!this.regionList) {
      return;
    }

    const citiesFound: ExpansibleRegionTree[] = [];

    (function findChildren(node: (RegionTree | Region)[]) {
      node.forEach((x) => {
        if ((x as RegionTree).children) {
          findChildren((x as RegionTree).children);
        } else if (citiesIds.some((id) => x.value === id)) {
          citiesFound.push(x);
        }
      });
    })(this.regionList);

    this.selectedCities = citiesFound.sort((x, y) => x.label > y.label ? 1 : -1);
  }

  writeValue(value: number[]): void {
    this.value = value;
    this.selectedCities = [];
    this.getSelectedCities();
  }

  toggleExpandAll(expand: boolean) {
    (function findChildren(nodeList: ExpansibleRegionTree[]) {
      nodeList.forEach((x) => {
        if (x.children) {
          x.expanded = expand;
          findChildren(x.children);
        }
      });
    })(this.regionList);
  }

  // Allows Angular to register a function to call when the model (rating) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn;
  }
  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {}

  onChange = (value: number[]) => {};
  onTouched = () => {};
}
